module.exports = __webpack_public_path__ + "img/undTooth3.031b57e3.png";